import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { selectLevelById, selectLevelIds } from '../../data/levelsSlice'
import { selectCurrentLangId, selectNav } from '../languages/languagesSlice'
import { vocas } from '../../data/vocas'
import Board from './Board'
import VocaSheet from './VocaSheet'
import {
  GAME_STATUS,
  selectGameStatus,
  selectAllCards,
  startGame,
  initGameStatus,
  getInitialCards
} from './gameSlice'
import './Game.css'

const root = process.env.PUBLIC_URL

const Game = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const currentPath = history.location.pathname
  const gameStatus = useSelector(selectGameStatus)
  const cards = useSelector(selectAllCards)
  const currLangId = useSelector(selectCurrentLangId)
  const nav = useSelector(selectNav)

  useEffect(() => {
    let unlisten = history.listen((location, action) => {
      if (currentPath !== location.pathname) {
        dispatch(initGameStatus())
      }
    })
    return () => unlisten()
  }, [])

  const { id } = useParams()
  const level = useSelector(state => selectLevelById(state, id))
  const levelIds = useSelector(selectLevelIds)
  const levelVocas = vocas[id]
  const thumbnail = `${root}/assets/game/img/levels/${level.folder}/thumbnail.png`
  const imgLevelItems = `${root}/assets/game/img/levels/${level.folder}/items.png`

  const handleClick__BtnStart = () => {
    dispatch(startGame(getInitialCards(levelVocas)))
  }

  const handleClick__BtnRestart = () => {
    dispatch(startGame(getInitialCards(levelVocas)))
  }

  const handleClick__BtnRandomStart = () => {
    dispatch(initGameStatus())
    let levelId = levelIds[Math.floor(Math.random() * levelIds.length)]
    history.push(`/game/${levelId}`)
  }

  return (
    <section className="game container">
      <div>
        {gameStatus !== GAME_STATUS.WAITING_START
          ? <Board
              imgLevelItems={imgLevelItems}
              cards={cards}
              lang={currLangId}
              onRestart={handleClick__BtnRestart}
              onRandomStart={handleClick__BtnRandomStart}
            />
          : <div className="splash-screen">
              <img src={thumbnail} />
              <button className="btn btn-xl" onClick={handleClick__BtnStart}>{nav.start}</button>
            </div>
        }
      </div>
      <VocaSheet imgLevelItems={imgLevelItems} vocas={levelVocas} lang={currLangId} />
    </section>
  )
}

export default Game